import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryProvider }   from '@/providers/QueryProvider';
import { AuthProvider }    from '@/providers/AuthProvider';
import { ToastProvider }   from '@/providers/ToastProvider';
import ProtectedRoute      from '@/components/ProtectedRoute';
import AppLayout           from '@/components/layout/AppLayout';

// Pages
import LoginPage           from '@/pages/auth/LoginPage';
import DashboardPage       from '@/pages/dashboard/DashboardPage';
import IngredientsListPage from '@/pages/ingredients/IngredientsListPage';
import IngredientFormPage  from '@/pages/ingredients/IngredientFormPage';
import RecipesListPage     from '@/pages/recipes/RecipesListPage';
import RecipeFormPage      from '@/pages/recipes/RecipeFormPage';
import RecipeDetailPage    from '@/pages/recipes/RecipeDetailPage';
import SuppliersPage       from '@/pages/suppliers/SuppliersPage';
import CategoriesPage      from '@/pages/categories/CategoriesPage';
import UsersPage           from '@/pages/users/UsersPage';
import KitchenListPage     from '@/pages/kitchen/KitchenListPage';
import KitchenDetailPage   from '@/pages/kitchen/KitchenDetailPage';
import SettingsPage        from '@/pages/settings/SettingsPage';

export default function App() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected — require any authenticated role */}
              <Route element={<ProtectedRoute />}>
                <Route element={<AppLayout />}>
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard"    element={<DashboardPage />} />
                  <Route path="ingredients"  element={<IngredientsListPage />} />
                  <Route path="ingredients/new"     element={<IngredientFormPage />} />
                  <Route path="ingredients/:id/edit" element={<IngredientFormPage />} />
                  <Route path="recipes"      element={<RecipesListPage />} />
                  <Route path="recipes/new"          element={<RecipeFormPage />} />
                  <Route path="recipes/:id"           element={<RecipeDetailPage />} />
                  <Route path="recipes/:id/edit"      element={<RecipeFormPage />} />
                  <Route path="suppliers"    element={<SuppliersPage />} />
                  <Route path="categories"   element={<CategoriesPage />} />
                  <Route path="users"        element={<UsersPage />} />
                  <Route path="settings"     element={<SettingsPage />} />
                </Route>
              </Route>

              {/* Kitchen display — separate layout, readonly allowed */}
              <Route element={<ProtectedRoute />}>
                <Route path="kitchen"         element={<KitchenListPage />} />
                <Route path="kitchen/:id"     element={<KitchenDetailPage />} />
              </Route>

              {/* Catch-all */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryProvider>
  );
}
